"use strict";

function initSolarLeadFormStepper() {
	const solarLeadForm = '.js-solar-lead-form',
		step = '.js-step',
		elementSolarLeadForm = document.querySelector(solarLeadForm);

	if (elementSolarLeadForm) {
		const elementSteps = elementSolarLeadForm.querySelectorAll(step);

		elementSteps.forEach(step => {

			step.addEventListener('click', function () {
				document.getElementById("__currentPage").setAttribute("value", index);
				document.forms[this.getAttribute("data-form-id")].submit();
			});

		});

	}

}

document.addEventListener("DOMContentLoaded", function () {
	initSolarLeadFormStepper();
});
